<template>
	<!-- v-model="dotacoesSelecionadas" -->
	<v-data-table
		:headers="headers"
		:items="dotacoesDecreto"
		hide-default-footer
		:no-data-text="noDataMessage"
		single-expand
		:expanded.sync="expanded"
		item-key="id"
		show-expand
	>
		<template v-slot:expanded-item="{ headers, item }">
			<td :colspan="headers.length">
				<v-row>
					<v-col md="1"> <b>Nr.:</b> {{ item.dotacao.numeroDotacao }} </v-col>
					<v-col md="1"> <b>Ano:</b> {{ item.dotacao.anoOrcamento }} </v-col>
					<v-col md="10">
						<b>Órgão:</b> {{ item.dotacao.orgaoCodigo }} - {{ item.dotacao.orgaoDescricao }}
					</v-col>
					<v-col md="6">
						<b>Função:</b> {{ item.dotacao.funcaoCodigo }} - {{ item.dotacao.funcaoDescricao }}
					</v-col>
					<v-col md="6">
						<b>Subfunção:</b> {{ item.dotacao.subfuncaoCodigo }} -
						{{ item.dotacao.subfuncaoDescricao }}
					</v-col>
					<v-col md="6">
						<b>Programa:</b> {{ item.dotacao.programaCodigo }} -
						{{ item.dotacao.programaDescricao }}
					</v-col>
					<v-col md="6">
						<b>Ação:</b> {{ item.dotacao.acaoCodigo }} - {{ item.dotacao.acaoDescricao }}
					</v-col>
					<v-col md="12">
						<b>Clas. Economica:</b> {{ item.dotacao.economicaCodigo }} -
						{{ item.dotacao.economicaDescricao }}
					</v-col>
					<v-col md="6">
						<b>Fonte:</b> {{ item.dotacao.fonteCodigo }} - {{ item.dotacao.fonteDescricao }}
					</v-col>
					<v-col md="6">
						<b>Cód. Aplicação:</b> {{ item.dotacao.aplicacaoCodigo }} -
						{{ item.dotacao.aplicacaoDescricao }}
					</v-col>
					<v-col md="3">
						<b>Valor Fixado Inicial:</b> {{ item.dotacao.valorFixadoInicial$ }}
					</v-col>
					<v-col md="3">
						<b>Valor Suplementado:</b> {{ item.dotacao.valorSuplementado$ }}
					</v-col>
					<v-col md="3"> <b>Valor Anulado:</b> {{ item.dotacao.valorAnulado$ }} </v-col>
					<v-col md="3">
						<b>Valor Fixado Final:</b> {{ item.dotacao.valorFixadoFinal$ }}
					</v-col>
				</v-row>
			</td>
		</template>
		<template v-slot:[`item.actions`]="{ item }" v-if="dotEmenda">
			<v-btn
				color="danger"
				small
				@click="removeItem(item)"
				:disabled="readOnly"
			>
				Remover dotação
			</v-btn>
		</template>

        <template v-slot:[`item.valorAnulado`]="props" v-if="dotAnular">			
			<v-edit-dialog :return-value.sync="props.item.valorAnulado$" @open="guardaValorAnulado(props.item.valorAnulado)" @save="verificaValorAnulado(props.item,props.item.valorAnulado)">
				{{ props.item.valorAnulado$ }}
				<template v-slot:input>
					<vuetify-money
						v-model="props.item.valorAnulado"
						label="Informe o valor"
						:options="{
							locale: 'pt-BR',
							prefix: 'R$',
							suffix: '',
							length: 11,
							precision: 2
						}"
						:properties="{
							rules: [isNumeric],
							required: true,
							'single-line': true
						}"
					/>
				</template>
			</v-edit-dialog>
        </template>
		<template v-else v-slot:[`item.valorAnulado`]="props">
			{{ props.item.valorAnulado$ }}
        </template>

        <template v-slot:[`item.valorSuplementado`]="props" v-if="dotSup">			
			<v-edit-dialog :return-value.sync="props.item.valorSuplementado$">
				{{ props.item.valorSuplementado$ }}
				<template v-slot:input>
					<vuetify-money
						v-model="props.item.valorSuplementado"
						label="Informe o valor"
						:options="{
							locale: 'pt-BR',
							prefix: 'R$',
							suffix: '',
							length: 11,
							precision: 2
						}"
						:properties="{
							rules: [isNumeric],
							required: true,
							'single-line': true
						}"
					/>
				</template>
			</v-edit-dialog>
        </template>
		<template v-else v-slot:[`item.valorSuplementado`]="props">
			{{ props.item.valorSuplementado$ }}
        </template>

	</v-data-table>
</template>

<script>
export default {
	props: ['value', 'readOnly', 'dotEmenda', 'dotAnular', 'dotSup'],
	data() {
		let dotacoesDecreto = [...this.value];
		dotacoesDecreto.forEach(d => {
			d.dotacao.valorFixadoInicial$ = this.setMascara(d.dotacao.valorFixadoInicial);
			d.dotacao.valorSuplementado$ = this.setMascara(d.dotacao.valorSuplementado);
			d.dotacao.valorAnulado$ = this.setMascara(d.dotacao.valorAnulado);
			d.dotacao.valorFixadoFinal$ = this.setMascara(d.dotacao.valorFixadoFinal);
			d.valorAnulado$ = this.setMascara(d.valorAnulado);
			d.valorSuplementado$ = this.setMascara(d.valorSuplementado);
		});

		return {
			dotacoesDecreto,
			headers: [
				{ text: 'Nr. Despesa', value: 'dotacao.numeroDotacao' },
				{ text: 'Ano', value: 'dotacao.anoOrcamento' },
				//{ text: 'Ação', value: 'acaoCodigo' },
				//{ text: 'Fonte', value: 'fonteCodigo' },
				{ text: 'Valor Fixado Final', value: 'dotacao.valorFixadoFinal$' },
				{ text: 'Valor Suplementado', value: 'valorSuplementado' },
				{ text: 'Valor Anulado', value: 'valorAnulado' },
				//{ text: 'Valor Fixado Final', value: 'valorFixadoFinal$' },
				{ text: '', value: 'data-table-expand' },
				{ text: '', value: 'actions', sortable: false }
			],
			noDataMessage: 'Não existem dotações para este decreto.',
			expanded: [],
			//itemsPerPage: 5,
			//page: 1,
			//dotacoesSelecionadas: [],
			isNumeric: v => isNaN(parseFloat(v)) == false || 'Valor deve ser numérico!',
			valorAnuladoAnterior: 0
		};
	},
	
	watch: {
		value: {
			deep: true,
			handler() {
				let dotacoesDecreto = [...this.value];
				dotacoesDecreto.forEach(d => {
					d.dotacao.valorFixadoInicial$ = this.setMascara(d.dotacao.valorFixadoInicial);
					d.dotacao.valorSuplementado$ = this.setMascara(d.dotacao.valorSuplementado);
					d.dotacao.valorAnulado$ = this.setMascara(d.dotacao.valorAnulado);
					d.dotacao.valorFixadoFinal$ = this.setMascara(d.dotacao.valorFixadoFinal);
					d.valorAnulado$ = this.setMascara(d.valorAnulado);
					d.valorSuplementado$ = this.setMascara(d.valorSuplementado);
				});

				this.dotacoesDecreto = dotacoesDecreto;
			}
		}

		// dotacoesSelecionadas(value) {
		// 	this.$emit('clicar', value);
		// }
	},

	mounted() {
		if (this.dotEmenda) {
			this.itemsPerPage = 1000;
		}
		else {
			this.itemsPerPage = 5;
		}
	},

	methods: {
		setMascara(v) {
			return parseFloat(v).toLocaleString('pt-BR', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
				style: 'currency',
				currency: 'BRL'
			});
		},
		removeItem(item) {
			this.dotacoesDecreto = this.dotacoesDecreto.filter(d => d !== item);
			this.$emit('input', this.dotacoesDecreto);
		},

		rowClick(evento, dados) {
			this.$emit('clicar', dados.item);
		},

		guardaValorAnulado(vlAnuladoAnterior) {
			this.valorAnuladoAnterior = vlAnuladoAnterior;
		},

		verificaValorAnulado(item,valorAnulado) {
			if (valorAnulado > item.dotacao.valorFixadoFinal) {
				item.valorAnulado = this.valorAnuladoAnterior;
				this.$root.dialog = { title: 'Valor anulado inválido', msg: 'Valor anulado não pode ser maior que valor fixado final.' };
			}
		}

	}
};
</script>
